import { useIsLoading } from 'affiny-core/hooks';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { authActions } from 'affiny-core/redux/actions/appBootstrapActions';
import { Fallback } from 'affiny-ui/src';
import React, { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';

interface IAppBootstrap {
  children: ReactNode;
}

export const AppBootstrap = ({ children }: IAppBootstrap) => {
  const dispatch = useDispatch();
  const isLoading = useIsLoading(EAsyncEventTypes.BOOTSTRAP_APP);

  useEffect(() => {
    dispatch(authActions.bootstrapApp());
  }, [dispatch]);

  if (isLoading) return <Fallback delay={1000} />;

  return <>{children}</>;
};
